// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1___18a1f0353172513dbc2{/*!*/}.FeedbackModal-cls2__dd4fd42be15b1128eb74{position:absolute;top:16px;right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___18a1f0353172513dbc2",
	"cls2": "FeedbackModal-cls2__dd4fd42be15b1128eb74 FeedbackModal-cls1___18a1f0353172513dbc2"
};
export default ___CSS_LOADER_EXPORT___;
